import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DBOSHomepage from './components/DBOSHomepage';
import SmartWeb from './pages/SmartWeb';
import SmartTraffic from './pages/SmartTraffic';
import Technology from './pages/Technology';
import Resources from './pages/Resources';
import OurStory from './pages/OurStory';
import SmartData from './pages/SmartData';
import SmartShop from './pages/SmartShop';
import SmartMail from './pages/SmartMail';
import SmartFinance from './pages/SmartFinance';
import Terms from './pages/legal/Terms';
import Privacy from './pages/legal/Privacy';
import Cookies from './pages/legal/Cookies';
import DPA from './pages/legal/DPA';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DBOSHomepage />} />
        <Route path="/solutions/smartweb" element={<SmartWeb />} />
        <Route path="/solutions/smarttraffic" element={<SmartTraffic />} />
        <Route path="/smartweb" element={<SmartWeb />} />
        <Route path="/smarttraffic" element={<SmartTraffic />} />
        <Route path="/technology" element={<Technology />} />
        <Route path="/news" element={<Resources />} />
        <Route path="/our-story" element={<OurStory />} />
        <Route path="/smartdata" element={<SmartData />} />
        <Route path="/smartshop" element={<SmartShop />} />
        <Route path="/smartmail" element={<SmartMail />} />
        <Route path="/smartfinance" element={<SmartFinance />} />
        <Route path="/solutions/smartdata" element={<SmartData />} />
        <Route path="/legal/terms" element={<Terms />} />
        <Route path="/legal/privacy" element={<Privacy />} />
        <Route path="/legal/cookies" element={<Cookies />} />
        <Route path="/legal/dpa" element={<DPA />} />
      </Routes>
    </Router>
  );
}

export default App;
